/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Aegis from 'aegis-web-sdk';

// 接入Aegis
let _isDevelopment = process.env.NODE_ENV === 'development';
const _startTime = Date.now();
const OPEN_WORKSPACE_EVENT = 'custom_event/open_workspace';
const CLUB_OPEN_WORKSPACE_EVENT = 'custom_event/club/open_workspace';

const WORKSPACE_STATUS_EVENT = 'custom_event/workspace_status';
const CLUB_WORKSPACE_STATUS_EVENT = 'custom_event/club/workspace_status';

const AEGIS_ID_TESTING = 'gQlQWfgna8znyZ3E2G';
const AEGIS_ID_SAAS = 'JjgGKclJP1E0pRaXqb';
const AEGIS_ID_QCLOUD = 'xEKagHQqVOD9E7jRZq';

let publicConfig = {};

const getId = () => {
  const { environment } = publicConfig;
  if (_isDevelopment || !environment || environment !== 'production') {
    return AEGIS_ID_TESTING; // 测试 id
  }
  const hostname = window.location.hostname;
  return hostname.includes('cloudstudio') ? AEGIS_ID_SAAS : hostname.includes('tencent') ? AEGIS_ID_QCLOUD : null;
};

const isClub = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('tencent')) {
    return false;
  }
  const { cloudStudioUrl = '' } = publicConfig;
  const cloudStudioHost = cloudStudioUrl.replace(/^https?:\/\//, '');
  return hostname === cloudStudioHost || hostname.startsWith('club.');
};

export let aegis = null;

export function initializeAegis(data = {}) {
  publicConfig = data;
  const id = getId();
  if (!id) {
    return;
  }
  aegis = new Aegis({
    id, // 上报 id
    env: process.env.NODE_ENV,
    reportApiSpeed: true, // 接口测速
    reportAssetSpeed: true, // 静态资源测速
    spa: true, // spa 应用页面跳转的时候开启 pv 计算
    websocketHack: true, // 监控界面的websocket 错误
    api: {
      injectTraceHeader: 'traceparent',
      injectTraceUrls: [/cloudstudio.net/, /cloud.tencent.com/],
    },
  });
}

export const once = (fn) => {
  let called = false;
  return function (...args) {
    if (called) return;
    called = true;
    return fn.apply(this, args);
  };
};

export const logWorkSpaceSpeed = once((incompatibleType, startupType, error) => {
  const prefix = [incompatibleType, startupType].filter((i) => i).join('_');
  const url = isClub() ? CLUB_OPEN_WORKSPACE_EVENT : OPEN_WORKSPACE_EVENT;
  logSpeed(url, prefix, error);
});

// 启动工作空间错误日志上报
export const logWorkSpaceStatusError = once((error) => {
  const url = isClub() ? CLUB_WORKSPACE_STATUS_EVENT : WORKSPACE_STATUS_EVENT;
  logSpeed(url, '', error);
});

export const logSpeed = (url, extMsg, error) => {
  const duration = Date.now() - _startTime;
  console.log(
    `CUSTOM_EVENT logSpeed aegis_id=${aegis?.config?.id} event=${url}, duration=${duration}ms, ext3=${extMsg}, error=${error}`,
  );
  aegis?.speedLogPipeline({
    url,
    isHttps: window.location.protocol === 'https:',
    method: 'get',
    type: 'fetch',
    duration,
    status: !error ? 200 : 500, // HTTP Code 成功率
    isErr: !error ? 0 : 1, // retcode 成功路
    ext1: !error ? 'success' : error.message || error.msg || error,
    ext2: window?.location?.href,
    ext3: extMsg || '',
  });
};
